import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { openExternalUrl } from 'core/utils/url';
import { useBellNotificationsContext } from 'notifications/states';
import { IBellNotification, IBellNotificationCta } from 'notifications/types';
import { getNotificationInternalPath } from 'notifications/utils/notification';

export const useOpenNotification = () => {
  const navigate = useNavigate();

  const { markRead } = useBellNotificationsContext();

  const openAction = useCallback(
    (notification: IBellNotification, cta: IBellNotificationCta) => {
      markRead(notification.id);

      if (cta.onClick) {
        cta.onClick();

        return;
      }

      if (!cta.href) {
        return;
      }

      if (cta.external) {
        openExternalUrl(cta.href);

        return;
      }

      navigate(cta.href);
    },
    [markRead, navigate]
  );

  const openNotification = useCallback(
    (notification: IBellNotification) => {
      markRead(notification.id);

      const internalPath = getNotificationInternalPath(notification);

      if (internalPath) {
        navigate(internalPath);
      }
    },
    [markRead, navigate]
  );

  return { openAction, openNotification };
};
